<template>
  <div
    class="container wishes_wrap personal_page"
    :class="[{noBirthInfo:!birthdayPersonInfo.hasBirthday},{today:birthdayPersonInfo.daysFromBirthday==0}]"
  >
    <div class="wishMainWrap" v-if="dataLoaded&&!wishDetailIsDel">
      <!-- 生日当天的界面 -->
      <div class="info_wrap" v-if="birthdayPersonInfo.hasBirthday">
        <div class="b_user_info">
          <div class="user_tag">
            <span>{{ birthdayPersonInfo.realName | lastName}}</span>
            <i></i>
          </div>
          <dl>
            <dt>
                <Organization :name="birthdayPersonInfo.realName" type="userName" :openid="birthdayPersonInfo.memberKeyRaw" :useOpenData="birthdayPersonInfo.useOpenData" ></Organization>
            </dt>
            <dd>{{birthdayPersonInfo.birthday}}&nbsp;|&nbsp;{{birthdayPersonInfo.constellation}}</dd>
            <dd
              v-if="birthdayWishDetail.totalRecord>=0"
            >已收到 {{birthdayWishDetail.totalRecord}} 份爱与祝福</dd>
          </dl>
        </div>
        <div class="day_timer" v-if="birthdayPersonInfo.daysFromBirthday==0">
          <p>生日快乐</p>
        </div>
        <div
          class="day_timer"
          v-if="birthdayPersonInfo.daysFromBirthday&&birthdayPersonInfo.daysFromBirthday>0"
        >
          <p>距离生日(天)</p>
          <div class="days">
            <span
              v-for="item in daysFromBirthdayArray(birthdayPersonInfo.daysFromBirthday)"
            >{{item}}</span>
          </div>
        </div>
      </div>
      <div v-if="birthdayPersonInfo.hasBirthday">
        <div class="wishes_board">
          <div class="title_margin"></div>
          <div class="title_wrap">
            <span class="title_line"></span>
            <h2>祝福留言</h2>
            <span class="title_line"></span>
          </div>
          <div class="title_margin"></div>
          <!-- 从消息通知进入的显示 -->
          <div class="show_wish_one_item" v-if="wishId">
            <div class="wish_board_item">
              <div class="b_user_tag">{{wishDetailItem.fromName | lastName}}</div>
              <div class="b_wish_messages">
                <p class="b_user_name">
                    <span><Organization :name="wishDetailItem.fromName" type="userName" :openid="wishDetailItem.memberKeyRaw" :useOpenData="wishDetailItem.useOpenData" ></Organization></span>
                </p>
                <!-- <p class="b_date">{{wishDetailItem.createAt}}</p> -->
                <p class="wish_text_get">{{wishDetailItem.content}}</p>
                <div class="wish_gift_img" v-if="wishDetailItem.imageUrl">
                  <img :src="wishDetailItem.imageUrl" />
                  <p>{{wishDetailItem.imageDescription}}</p>
                </div>
                <template v-if="wishDetailItem.voiceUrl">
                  <myAudio :audioSrc="wishDetailItem.voiceUrl"></myAudio>
                </template>
                <div class="opt_wrap">
                  <p class="b_date">{{wishDetailItem.createAt}}</p>
                  <div class="wish_btns">
                    <a
                      href="javascript:;"
                      class="answer_wishes"
                      v-if="wishDetailItem.canReply"
                      @click="addWishReply(wishDetailItem.id,wishDetailItem.fromName)"
                    >回复</a>
                    <span v-if="wishDetailItem.canReply">·</span>
                    <a
                      href="javascript:;"
                      class="del_wishes"
                      v-if="wishDetailItem.canDel"
                      @click="delWishDetaiFun(wishDetailItem.id)"
                    >删除</a>
                  </div>
                </div>
                <div
                  class="wishes_back_item"
                  v-for="(item,index) in wishDetailItem.wishReplyList"
                  :class="'wsb_'+((index+1)%7)"
                >
                  <div class="b_user_tag">{{wishDetailItem.toName | lastName}}</div>
                  <div class="b_wish_messages">
                    <p class="b_user_name">
                        <Organization :name="wishDetailItem.toName" type="userName" :openid="birthdayPersonInfo.memberKeyRaw" :useOpenData="birthdayPersonInfo.useOpenData" ></Organization>
                      <span>回复</span>
                      <span><Organization :name="item.replyName" type="userName" :openid="wishDetailItem.memberKeyRaw" :useOpenData="wishDetailItem.useOpenData" ></Organization></span>
                    </p>
                    <p class="wish_text_get">{{item.content}}</p>
                    <div class="opt_wrap">
                      <p class="b_date" v-if="item.createAt">{{item.createAt}}</p>
                      <div class="wish_btns">
                        <a
                          href="javascript:;"
                          class="del_wishes"
                          v-if="item.canDel"
                          @click="delReplyFun(item.id)"
                        >删除</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <a
              href="javascript:;"
              class="more_wish_btn"
              v-if="birthdayWishDetail.totalRecord>1&&!showWishList"
              @click="showWishListFun"
            >
              查看全部{{birthdayWishDetail.totalRecord}}条祝福
              <i></i>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="wish_deleted" v-if="wishDetailIsDel">
      <img src="../../assets/img/birthday/deleted_icon.png" />
      <p>该留言已被删除</p>
    </div>
    <div class="no_in_main_org" v-if="noInMainOrg">
      <img src="../../assets/img/birthday/no_birthday_info.png" />
      <dl>
        <dt>还没有生日信息哦</dt>
        <dd>联系管理员添加</dd>
      </dl>
    </div>
    <loading v-show="isShowLoading"></loading>
    <x-dialog v-model="tipDialog" class="dialog-pop" :scroll="false">
      <div class="content-wrap">
        <p>{{tipText}}</p>
      </div>
      <div class="btn-wraps">
        <a href="javascript:;" class="btn-txt" @click="tipDialog=false">知道啦</a>
      </div>
    </x-dialog>
    <x-dialog v-model="sureDialog" class="dialog-pop" :scroll="false">
      <div class="content-wrap">
        <p>{{sureText}}</p>
      </div>
      <div class="btn-wraps">
        <a href="javascript:;" class="btn-txt" @click="sureDialog=false">取消</a>
        <a href="javascript:;" class="btn-txt" @click="delWishes">确定</a>
      </div>
    </x-dialog>
    <home :ishome="0"></home>
  </div>
</template>
<script>
import loading from "../common/loading.vue";
import XDialog from "vux/src/components/x-dialog/index.vue";
import Cookies from "js-cookie";
import home from "../common/home.vue";
import Organization from "@/components/common/organization.vue";
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      adding: false,
      dataLoaded: false,
      isShowLoading: false,
      tipDialog: false,
      tipText: "",
      sureDialog: false,
      sureText: "",
      sureDialogType: 1, //1删除祝福2 删除回复
      delWishId: "",
      wishedSelectedIndex: -1,
      showWishList: false,
      wishDetailItem: {
        wishReplyList: []
      },
      wishDetailIsDel: false,
      noInMainOrg: false,
      doWishDetailDel: false,
      wxShareData: {},
      ddShareData: {},
      share_info: {},
    };
  },
  components: {
    loading,
    XDialog,
    home,
    Organization
  },
  computed: {
    ...mapGetters({
      userLoginFinish: "userLoginFinish",
      birthdayPersonInfo: "getBirthdayPersonInfo",
      birthdayWishDetail: "getBirthdayWishDetail",
      delWishReply: "getDelWishReply",
      delWish: "getDelWish",
      corpId: "getcorpId"
    }),
    wishId() {
      return this.$route.query.wishId;
    },
    subUid() {
      console.log("this.$route.query.subUid;", this.$route.query.subUid);
      return this.$route.query.subUid;
    },
    cookieCorpId() {
      return Cookies.get("current_corp_id");
    },
    queryCorpId() {
      return this.$route.query.corpId;
    }
  },
  watch: {
    userLoginFinish() {
      if (val) {
        this.initPageData();
      }
    },
    birthdayPersonInfo(cval) {
      this.isShowLoading = false;
      if (typeof cval == "object") {
        this.dataLoaded = true;
        this.noInMainOrg = false;
        //去生日蜡烛页面
        this.$store.dispatch("doBirthdayIntro", { subUid: cval.subUid });
      } else {
        this.noInMainOrg = true;
      }
      this.hideShare();
    },
    delWishReply(cval) {
      this.refreshWishDetail();
    },
    delWish(cval) {
      this.refreshWishDetail();
    },
    birthdayWishDetail(cval) {
      if (cval.wishDetail) {
        this.wishDetailItem = cval.wishDetail;
      } else {
        this.wishDetailIsDel = true;
        this.isShowLoading = false;
      }
    }
  },
  filters: {
    lastName: function(value) {
      if (value) {
        return value.substring(value.length - 1, value.length);
      }
    }
  },
  methods: {
    showMsg(txt) {
      this.tipText = txt;
      this.tipDialog = true;
    },
    initPageData() {
      if (this.subUid) {
        this.$store.dispatch("doBirthdayPersonInfo", { subUid: this.subUid });
        this.$store.dispatch("doBirthdayWishDetail", {
          wishId: this.wishId,
          subUid: this.subUid
        });
      } else {
        this.$store.dispatch("doBirthdayPersonInfo");
        this.$store.dispatch("doBirthdayWishDetail", { wishId: this.wishId });
      }
    },
    refreshWishDetail() {
      this.sureDialog = false;
      if (this.subUid) {
        this.$store.dispatch("doBirthdayWishDetail", {
          wishId: this.wishId,
          subUid: this.subUid
        });
      } else {
        this.$store.dispatch("doBirthdayWishDetail", { wishId: this.wishId });
      }
    },
    showWishListFun() {
      // this.showWishList=true;
      let corpId = this.$route.query.corpId;
      if (!corpId) corpId = this.corpId;
      if (this.subUid) {
        this.$router.push({
          name: "birthdayPersonal",
          query: {
            subUid: this.subUid,
            corpId: corpId
          }
        });
      } else {
        this.$router.push({
          name: "birthdayPersonal",
          query: {
            corpId: corpId
          }
        });
      }
    },
    delReplyFun(replyId) {
      this.sureText = "确定要删除留言吗？";
      this.sureDialogType = 2;
      this.delWishId = replyId;
      this.sureDialog = true;
      // this.$store.dispatch('doBirthdayWishReplyDel',{replyId:replyId});
    },
    delWishDetaiFun(wishId) {
      this.sureText = "确定要删除祝福吗？";
      this.sureDialogType = 1;
      this.delWishId = wishId;
      this.sureDialog = true;
      // this.$store.dispatch('doDelWish',{wishId:wishId});
      // this.doWishDetailDel=true;
    },
    delWishes() {
      if (this.sureDialogType == 1) {
        this.$store.dispatch("doDelWish", { wishId: this.delWishId });
      }
      if (this.sureDialogType == 2) {
        this.$store.dispatch("doBirthdayWishReplyDel", {
          replyId: this.delWishId
        });
      }
    },
    addWishReply(replyId, name) {
      this.$router.push({
        name: "birthdayAnswer",
        query: {
          replyId: replyId,
        //   name: name
        }
      });
    },
    hideShare() {
      let _this = this;
      // var loadjs = require("loadjs");
      //   loadjs(
      //     ["http://g.aghcdn.com/agh_c_share"],
      //     "aghojs"
      //   );
      // loadjs.ready("aghojs", function() {
      this.wxShareData.allowShare = false;
      this.ddShareData.type = 0;
      this.share_info = {};
      if(this.project_name !== 'changjiangcunchu'){
        new agho.WxShare(this.wxShareData.allowShare, this.share_info);
        new agho.DdShare(this.ddShareData.type, this.share_info);
      };
   
      // });
    },
    daysFromBirthdayArray(daysFromBirthday) {
      return String(daysFromBirthday).split("");
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.isShowLoading = true;
    });
    if (this.userLoginFinish) {
      this.initPageData();
    }
  },
    created(){
       
    }
};
</script>